

(function( ){


//------------------------------------------------------------------------------------------------------------------------------


	var Main = function( )
	{
		var _this = this , i ;

		//  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -

		// この中に処理を書いていってください。






		//  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -

		// リサイズイベントを使うときは、この_onResize内に処理を書いてください。
		// リサイズイベントを綱わないようでしたら決してください。
		// var _onResize = function( )
		// {

		// }

		// _onResize( ) ;
		// FitContents.addTask( _onResize ) ;


		new CollaboCharacter( ) ;
		new KV( ) ;
	}


//------------------------------------------------------------------------------------------------------------------------------


	var KV = function( )
	{
		var _this = this , i ;

		var _root = document.getElementById( "intro" ) ;

		var _to_anime = _root.getElementsByClassName( "to-anime" )[0] ;

		ScrollEnterEvent.add( _root ,
			{
				marginScale:0.2 ,
				func:function( )
				{
					_to_anime.className = _to_anime.className + " show" ;
				}
			} ) ;
	}


//------------------------------------------------------------------------------------------------------------------------------


	var CollaboCharacter = function( )
	{
		var _this = this , i ;

		var _root = document.getElementById( "character" ) ;

		var slickInitObj =
		{
			arrows:true,
			infinite: false ,
			slidesToShow: 1 ,
			slidesToScroll: 1 ,
			initialSlide:1 ,
			dots: false ,
			autoplay: false ,
			autoplaySpeed: 5000 ,
			swipeToSlide:true ,
			cssEase:"cubic-bezier(0.215, 0.610, 0.355, 1.000)" ,
			speed:350
	    };

		var target = _root.getElementsByClassName( "js-slick" ) ;
		$( target ).slick( slickInitObj ) ;


		// 神化もするキャラ用のnext、prev表示切り替え処理
		$( target[1] ).on('beforeChange', function( event, slick, currentSlide, nextSlide ){

			event.currentTarget.className = event.currentTarget.className.replace( /\sshinka|\skamika/gi , "" ) ;

			switch( nextSlide )
			{
				case 0 :
					break ;

				case 1 :
					event.currentTarget.className = event.currentTarget.className + " shinka" ;
					break ;

				case 2 :
					event.currentTarget.className = event.currentTarget.className + " kamika" ;
					break ;
			}
		});



		//

		var _char_detail = _root.getElementsByClassName( "char-detail" )[0] ;
		var _char = _char_detail.getElementsByClassName( "char" ) ;
		var _ball = _root.getElementsByClassName( "ball" ) ;

		var _onBall = function( evt )
		{
			switch( evt.type )
			{
				case "click" :
					var focus = _char[ evt.currentTarget.index ] ;
					var blur = _char_focus ;

					if( blur == focus )	return ;

					Tween.add.update( blur.style , { opacity:0 , time:0.15 , transition:"linear" , delay:0 } , { onComplete:function(){ blur.style.visibility="hidden"; } } ) ;

					_char_focus = focus ;
					focus.style.visibility = "visible";
					Tween.add.update( focus.style , { opacity:1 , time:0.15 , transition:"linear" , delay:0 } ) ;

					Tween.add.update( _char_detail.style , { height:_char_focus.offsetHeight+"px" , time:0.15 , transition:"linear" , delay:0 } ) ;
					break ;
			}
		}

		for( i = 0 ; i < _char.length ; i++ )
		{
			_char[i].style.visibility = "hidden" ;
			_char[i].style.opacity = 0 ;
			_char[i].index = i ;
			_ball[i].index = i ;
			_ball[i].addEventListener( "click" , _onBall ) ;
		}

		var _char_focus = _char[0] ;
		_char_focus.style.opacity = 1 ;
		_char_focus.style.visibility = "visible" ;

		_char_detail.style.height = _char_focus.offsetHeight + "px" ;



		//

		// var _onResize = function( )
		// {
		// 	_char_detail.style.height = _char_focus.offsetHeight+"px" ;
		// }
		// FitContents.onResize.add( _onResize ) ;

	};


	// var getOffsetTop = function( target , rootTarget )
	// {
	// 	rootTarget = rootTarget == undefined ? document : rootTarget ;
	// 	var top = target.offsetTop ;
	// 	var parent = target.parentNode ;

	// 	while( parent && parent != rootTarget )
	// 	{
	// 		var parentStyle = parent.currentStyle || document.defaultView.getComputedStyle( parent , '' ) ;

	// 		if( parent.offsetTop !== undefined && parentStyle.position != "static" )
	// 		{
	// 			top += parent.offsetTop ;
	// 		}
	// 		parent = parent.parentNode ;
	// 	}

	// 	return top ;
	// }


//------------------------------------------------------------------------------------------------------------------------------


	window.requestAnimationFrame = 	window.requestAnimationFrame ||
									window.webkitRequestAnimationFrame ||
									function( func ){ return setTimeout( func , 1000/60 ) ; } ;


	window.cancelAnimationFrame = 	window.cancelAnimationFrame ||
									window.webkitCancelAnimationFrame ||
									function( id ){ clearTimeout( id ) ; } ;


	document.readyState === "complete"
		? setTimeout( function(){ new Main( ) ; } , 1 )
		: document.addEventListener( "DOMContentLoaded", function(){ new Main( ) ; } ) ;


//------------------------------------------------------------------------------------------------------------------------------


} )( ) ;

